document.addEventListener('DOMContentLoaded', function(event) { 
  // Set active state for the very first menu items
  let subMenuItems = document.querySelectorAll('.dd-mega-menu__nav-link');
  let ddGrids = document.querySelectorAll('.dd-mega-menu__content');

  if (ddGrids.length > 0) {
    ddGrids.forEach(item => {
      item.querySelector('.dd-mega-menu__grid:nth-child(1)').classList.add('dd-mega-menu__grid--active');
    })
  }

  if (subMenuItems.length > 0) {
    subMenuItems.forEach(subMenuItem => {
      subMenuItem.addEventListener('mouseover', function(){
        let filter = this.dataset.filter;
        
        // Update active link
        this.closest('.dd-mega-menu__container').querySelector('.dd-mega-menu__nav-link--active').classList.remove('dd-mega-menu__nav-link--active');
        this.classList.add('dd-mega-menu__nav-link--active');

        // Update active grid
        if (this.closest('.dd-mega-menu__container').querySelector('.dd-mega-menu__grid--active')) {
          this.closest('.dd-mega-menu__container').querySelector('.dd-mega-menu__grid--active').classList.remove('dd-mega-menu__grid--active');
        }
        
        if (document.querySelector(`.dd-mega-menu__grid[data-filter="${filter}"]`)) {
          // this.closest('.dd-mega-menu__container').querySelector('.dd-mega-menu__grid--active').classList.remove('dd-mega-menu__grid--active');

          document.querySelector(`.dd-mega-menu__grid[data-filter="${filter}"]`).classList.add('dd-mega-menu__grid--active');
        }
      })
    })
  }

  /* Hamburger */
  document.querySelector('.js-hamburger').addEventListener('click', function(){
    document.querySelector('html').classList.toggle('overflow-hidden');
    this.classList.toggle('site-header__hamburger--active');
    this.closest('.site-header').classList.toggle('site-header--open');
    document.querySelector('.navigation-mobile').classList.toggle('navigation-mobile--active');
  });

  let dropdown = document.querySelector('.navigation-mobile');
  let items = dropdown.querySelectorAll('.navigation-mobile__list-item--has-dd');
  items.forEach(item => {
    item.addEventListener('click', (e)=>{
      if (e.target.classList.contains('navigation-mobile__list-item--has-dd')) {
        e.stopPropagation();
        e.preventDefault();
        slideAnim(item);
      }
    });
  });
  
  /* Open Dropdown */
  function slideAnim(item) {
    //console.log(e);
    let el = item;
    let body = el.querySelector('.navigation-mobile__dropdown');
    //console.log(body);
    let active = document.querySelector('.navigation-mobile__list-item--active');
    if (active) {
      active.classList.remove('navigation-mobile__list-item--animate');
      active.querySelector('.navigation-mobile__dropdown').style.height = "0px";
      active.querySelector('.navigation-mobile__dropdown').addEventListener('transitionend', () => {
        active.classList.remove('navigation-mobile__list-item--active')
      }, { once: true })
    }
    if (!el.classList.contains('navigation-mobile__list-item--active')) {
      el.classList.add('navigation-mobile__list-item--active', 'navigation-mobile__list-item--animate')
      body.style.height = 'auto';
      let height = body.offsetHeight + 'px';
      body.style.height = "0px";
      setTimeout(() => {
        body.style.height = height;
      }, 0);
    } else {
      el.classList.remove('navigation-mobile__list-item--animate');
      body.style.height = "0px";
      body.addEventListener('transitionend', () => {
        el.classList.remove('navigation-mobile__list-item--active');
      }, { once: true })
    }
  }

  /* Open 3rd level */
  document.querySelectorAll('.navigation-mobile__dropdown-item-link').forEach(link => {
    link.addEventListener('click', function(e){
      if (this.parentNode.querySelector('.navigation-mobile__grid')) {
        e.preventDefault();
        e.stopPropagation();

        let el = this;
        let body = el.parentNode.querySelector('.navigation-mobile__grid');
        //console.log(body);
        let active = document.querySelector('.navigation-mobile__dropdown-item-link--active');
        if (active) {
          // console.log('removing active');
          active.classList.remove('navigation-mobile__dropdown-item-link--animate');
          active.parentNode.querySelector('.navigation-mobile__grid').style.height = "0px";
          active.parentNode.querySelector('.navigation-mobile__grid').addEventListener('transitionend', () => {
            active.classList.remove('navigation-mobile__dropdown-item-link--active');
            el.closest('.navigation-mobile__list-item--active').querySelector('.navigation-mobile__dropdown').style.height = 'auto';
            let parentHeight = el.closest('.navigation-mobile__list-item--active').querySelector('.navigation-mobile__dropdown').offsetHeight + 'px';
            el.closest('.navigation-mobile__list-item--active').querySelector('.navigation-mobile__dropdown').style.height = parentHeight;
          }, { once: true })
        }
        if (!el.classList.contains('navigation-mobile__dropdown-item-link--active')) {
          // console.log('adding active');
          el.classList.add('navigation-mobile__dropdown-item-link--active', 'navigation-mobile__dropdown-item-link--animate')
          body.style.height = 'auto';
          let height = body.offsetHeight + 'px';
          body.style.height = "0px";
          setTimeout(() => {
            body.style.height = height;
            body.addEventListener('transitionend', () => {
              el.closest('.navigation-mobile__list-item--active').querySelector('.navigation-mobile__dropdown').style.height = 'auto';
              let parentHeight = el.closest('.navigation-mobile__list-item--active').querySelector('.navigation-mobile__dropdown').offsetHeight + 'px';
              el.closest('.navigation-mobile__list-item--active').querySelector('.navigation-mobile__dropdown').style.height = parentHeight;
            }, { once: true })
          }, 0); 
        }
      }
    });
  })

  /* Set header height as css var */
  if (window.innerWidth < 1024) {
    let headerHeight = document.querySelector('#shopify-section-header').offsetHeight;
    let announcementHeight = document.querySelector('#shopify-section-announcement-bar').offsetHeight ? document.querySelector('#shopify-section-announcement-bar').offsetHeight : 0;
    // console.log(headerHeight);
    // console.log(announcementHeight);
    let totalHeight = headerHeight + announcementHeight;
    // console.log(totalHeight);
    document.documentElement.style.setProperty('--hhm', `${totalHeight}px`);
  }
}, false);